export enum IconType {
    SRC = 'src',
    ICOMOON = 'icomoon',
    FONTAWESOME = 'fontawesome'
}
